"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.grade.title': 'Upgrade Account',
    'user.grade.free': 'Free',
    'user.grade.basic': 'Basic',
    'user.grade.pro': 'Pro',
    'user.grade.ultra': 'Ultra',
};
